import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

import Section from 'features/timesheets/TimesheetsPage/TimecardModal/Section';

import { cxHelpers } from 'util/className';
const { cx } = cxHelpers('TipsSection');

import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { formatDate } from 'util/dateTime';
import { toI18n } from 'util/i18n';

const numberToCurrency = value => (
  <NumberFormat
    value={value}
    prefix="$"
    decimalScale={2}
    fixedDecimalScale
    thousandSeparator=","
    decimalSeparator="."
    displayType="text"
  />
);

const TipsSection = ({
  cashTips,
  creditTips,
  tipOut,
  tipOutUpdatedAt,
  cashTipOutEligible,
}) => {
  const displayTipOutOnly = cashTipOutEligible && tipOut != null;
  return (
    <Box className={cx()}>
      <Section
        title={toI18n(
          displayTipOutOnly
            ? 'timecard_modal_v3.tips_section.tip_out_title'
            : 'timecard_modal_v3.tips_section.title'
        )}
        iconName="Money"
        expandedContent={null}
        collapsedContent={
          <Box>
            <Box mt={4}>
              {displayTipOutOnly ? (
                <Text variant="body" color="mono900">
                  {numberToCurrency(tipOut || 0)}
                </Text>
              ) : (
                <Box inlineBlock>
                  <Text variant="body" color="mono900">
                    {numberToCurrency(cashTips || 0)} /{' '}
                    {numberToCurrency(tipOut ?? creditTips ?? 0)}
                  </Text>
                </Box>
              )}
            </Box>
            {tipOutUpdatedAt && (
              <Box inlineBlock mt={16}>
                <Text
                  variant="bodySm"
                  fs={14}
                  color="mono700"
                  i18n="timecard_modal_v3.tips_section.tip_out_updated_at"
                  i18nProps={{
                    date: formatDate(tipOutUpdatedAt, 'trade_time'),
                  }}
                />
              </Box>
            )}
          </Box>
        }
        bottomBorder
        bottomPadding
      />
    </Box>
  );
};

TipsSection.propTypes = {
  cashTips: PropTypes.number,
  creditTips: PropTypes.number,
  tipOut: PropTypes.number,
  tipOutUpdatedAt: PropTypes.string,
  cashTipOutEligible: PropTypes.bool,
};

export default TipsSection;
